import { swaDate } from "@swa-ui/date";

export function getBoundDetails(segments, includeStopsData = false) {
  const boundGroups = segments?.reduce((groups, segment) => {
    const boundNumber = segment?.segmentDetails?.boundNumber || 1;

    if (!groups[boundNumber]) {
      groups[boundNumber] = [];
    }

    groups[boundNumber].push(segment);

    return groups;
  }, {});

  return Object.entries(boundGroups || {}).reduce((acc, [boundNumber, boundSegments]) => {
    const firstSegment = boundSegments[0]?.segmentDetails;
    const lastSegment = boundSegments[boundSegments.length - 1]?.segmentDetails;

    acc[`air_bound${boundNumber}_airportcodes`] = `${firstSegment?.departureStation || ""}:${
      lastSegment?.arrivalStation || ""
    }`;
    acc[`air_bound${boundNumber}_date`] = swaDate(firstSegment?.departureTime)?.format(
      "YYYY-MM-DD"
    );
    acc[`air_bound${boundNumber}_faretype`] = firstSegment?.fareFamily || "";

    if (includeStopsData) {
      acc[`air_bound${boundNumber}_stops`] = boundSegments.length - 1;
      acc[`air_bound${boundNumber}_stoptype`] = getStopsType(boundSegments);
    }

    return acc;
  }, {});
}

function getStopsType(segments) {
  let stopType = "direct";

  if (
    segments.length === 1 &&
    !segments[0]?.segmentDetails?.planeChange &&
    !segments[0]?.segmentDetails?.noPlaneChangeStops?.length
  ) {
    stopType = "nonstop";
  } else if (segments?.find((segment) => segment?.segmentDetails?.planeChange)) {
    stopType = "connecting";
  }

  return stopType;
}
